import React from 'react'
import withIcon from '@/components/withIcon'

const IconLocation = ({ className }) => {
  return (
    <svg
      className={className}
      fill="none"
      viewBox="0 0 16 16"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        clipRule="evenodd"
        d="M8 16s6-5.686 6-10A6 6 0 0 0 2 6c0 4.314 6 10 6 10Zm0-7a3 3 0 1 0 0-6 3 3 0 0 0 0 6Z"
        fill="currentColor"
        fillRule="evenodd"
      />
    </svg>
  )
}

export default withIcon(IconLocation)
